<form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex min-h-0 flex-1 flex-col gap-4">
  <lib-baa-scroll-container>
    <div class="flex flex-col gap-3">
      <h3 class="typo-h2 text-text-secondary">{{ 'express_app_baa_form_practice_details_heading' | translate }}</h3>

      <lib-input
        background="white"
        size="large"
        [label]="'express_app_baa_form_legal_name_label' | translate"
        formControlName="legalName"
        [hint]="isSubmitted() && form.controls['legalName'].invalid ? ('express_app_baa_form_legal_name_error' | translate) : ''"
        [state]="isSubmitted() && form.controls['legalName'].invalid ? 'error' : 'normal'"
      ></lib-input>

      <lib-input
        background="white"
        size="large"
        [label]="'express_app_baa_form_address_label' | translate"
        formControlName="address"
        [hint]="isSubmitted() && form.controls['address'].invalid ? ('express_app_baa_form_address_error' | translate) : ''"
        [state]="isSubmitted() && form.controls['address'].invalid ? 'error' : 'normal'"
      ></lib-input>

      <lib-input
        background="white"
        size="large"
        [label]="'express_app_baa_form_city_label' | translate"
        formControlName="city"
        [hint]="isSubmitted() && form.controls['city'].invalid ? ('express_app_baa_form_city_error' | translate) : ''"
        [state]="isSubmitted() && form.controls['city'].invalid ? 'error' : 'normal'"
      ></lib-input>

      <div class="flex w-full gap-3">
        <lib-dropdown-search
          class="w-1/2"
          size="large"
          formControlName="state"
          [label]="'express_app_baa_form_state_label' | translate"
          [options]="statesDropdownOptions"
          [hint]="isSubmitted() && form.controls['state'].invalid ? ('express_app_baa_form_state_error' | translate) : ''"
          [state]="isSubmitted() && form.controls['state'].invalid ? 'error' : 'normal'"
          [overlayMaxHeight]="'220px'"
          [overlayPositionStrategy]="[
            {
              originX: 'start',
              originY: 'bottom',
              overlayX: 'start',
              overlayY: 'top',
              offsetY: 0
            }
          ]"
        ></lib-dropdown-search>

        <lib-input
          background="white"
          class="!w-1/2"
          size="large"
          [label]="'express_app_baa_form_zip_label' | translate"
          formControlName="zip"
          [hint]="isSubmitted() && form.controls['zip'].invalid ? ('express_app_baa_form_zip_error' | translate) : ''"
          [state]="isSubmitted() && form.controls['zip'].invalid ? 'error' : 'normal'"
        ></lib-input>
      </div>

      <div class="flex flex-col items-center justify-center gap-2 rounded-3xl bg-background-light-grey py-5">
        <p class="typo-h5-book text-text-tertiary">{{ 'express_app_baa_form_signer_label' | translate }}</p>
        <p class="typo-h4-medium text-text-secondary">{{ form.controls['signerFullName'].value }}</p>
      </div>

      <p class="typo-h5-book mt-5 text-text-tertiary">
        {{ 'express_app_baa_form_agreement_text_prefix' | translate }}
        <a [href]="termsOfServiceUrl" target="_blank" rel="noopener noreferrer" class="font-semibold text-primary-blue underline">{{
          'express_app_baa_form_agreement_tos_link' | translate
        }}</a>
        {{ 'express_app_baa_form_agreement_text_and' | translate }}
        <a [href]="baaUrl" target="_blank" rel="noopener noreferrer" class="font-semibold text-primary-blue underline">{{
          'express_app_baa_form_agreement_baa_link' | translate
        }}</a>
      </p>
    </div>
  </lib-baa-scroll-container>

  <button
    type="submit"
    [disabled]="modalStore.isLoading()"
    class="btn-primary w-full shrink-0 justify-center bg-primary-blue px-10 py-2.5 active:bg-primary-blue"
  >
    {{ 'express_app_baa_form_sign_button' | translate }}
  </button>
</form>
